// extracted by mini-css-extract-plugin
module.exports = {"Icons_container":"ShareModal_Icons_container__1WvaM"};